export default "__VITE_ASSET__Brl_QBkS__"